<template>
  <v-sheet class="promotion" style="height: calc(100vh - 140px)">
    <v-row>
      <v-col md="2">
        <v-card class="mx-auto" style="border: 0.5px solid black">
          <v-card-actions>
            <v-list-item class="grow px-0">
              <v-list-item-content>
                <v-list-item-title
                  class="custom-form-label d-flex align-center"
                  style="font-weight: 600; font-size: 13px"
                >
                  <VAvatar :size="55" rounded color="black lighten-5" variant="tonal" class="me-2">
                    <v-icon size="34" color="white" dark>mdi-cash-refund</v-icon>
                  </VAvatar>
                  <span class="mb-1" style="max-width: 90px; display: inline-flex"
                      >Total Refund<br />
                      Last Month</span
                      
                  ></v-list-item-title
                >
              </v-list-item-content>
              <div align="center" justify="end">
                <span class="subheading">
                  <v-chip color="black" style="font-size: 13px; color: white; font-weight: 600">{{formatMoney(totalRefundLastMonth)
                    
                  }}</v-chip>
                </span>
              </div>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="2" >
        <v-card class="mx-auto" style="border: 0.5px solid indigo">
          <v-card-actions>
            <v-list-item class="grow px-0">
              <v-list-item-content>
                <v-list-item-title
                  class="custom-form-label d-flex align-center"
                  style="font-weight: 600; font-size: 13px;"
                >
                  <VAvatar :size="55" rounded color="indigo lighten-5" variant="tonal" class="me-2">
                    <v-icon size="34" color="indigo" dark>mdi-cash-refund</v-icon>
                  </VAvatar>
                  <span class="mb-1" style="max-width: 90px; display: inline-flex"
                      >Total Refund<br />
                      This Month</span
                      
                  >
                </v-list-item-title>
              </v-list-item-content>

              <div align="center" justify="end">
                <span class="subheading"
                  ><v-chip color="indigo" style="font-size: 13px; color: white; font-weight: 600"
                    >{{ formatMoney(totalRefundThisMonth) }}</v-chip
                  ></span
                >
              </div>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="2" class="pr-0">
        <v-card class="mx-auto" style="border: 0.5px solid #ef9a9a">
          <v-card-actions>
            <v-list-item class="grow px-0">
              <v-list-item-content>
                <v-list-item-title
                  class="custom-form-label custom-form-label d-flex align-center"
                  style="font-weight: 600; font-size: 13px;"
                >
                  <VAvatar :size="55" rounded color="red lighten-5" variant="tonal" class="me-3">
                    <v-icon size="34" color="red" dark>mdi-cash-multiple</v-icon>
                  </VAvatar>
                    <span class="mb-1" style="max-width: 90px; display: inline-flex"
                      >Total Rent Paid<br />
                      This Month</span
                    >
                   
                   </v-list-item-title
                >
               
              </v-list-item-content>

              <div align="center" justify="end">
                <span class="subheading ml-2"
                  ><v-chip color="red" style="font-size: 13px; color: white; font-weight: 600"
                    >{{ formatMoney(totalRentPaidThisMonth) }}</v-chip
                  ></span
                >
              </div>
 
            </v-list-item>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="2" class="pr-0">
        <v-card class="mx-auto" style="border: 0.5px solid orange">
          <v-card-actions>
            <v-list-item class="grow px-0">
              <v-list-item-content>
                <v-list-item-title
                  class="custom-form-label custom-form-label d-flex align-center"
                  style="font-weight: 600; font-size: 13px"
                >
                  <VAvatar :size="55" rounded color="orange lighten-5" variant="tonal" class="me-2">
                    <v-icon size="34" color="orange" dark>mdi-cash-multiple</v-icon>
                  </VAvatar>
                   <span class="mb-1" style="max-width: 90px; display: inline-flex"
                      >Total Rent Paid<br />
                      Last Month</span
                    > 
                  </v-list-item-title
                > 
              </v-list-item-content>

              <div align="center" justify="end">
                 <span class="subheading"
                  ><v-chip color="orange" style="font-size: 13px; color: white; font-weight: 600"
                    >{{ formatMoney(totalRentPaidLastMonth) }}</v-chip
                  ></span
                >
               
              </div>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="2">
        <v-card class="mx-auto" style="border: 0.5px solid #81c784">
          <v-card-actions>
            <v-list-item class="grow px-0">
              <v-list-item-content>
                <v-list-item-title
                  class="custom-form-label d-flex align-center"
                  style="font-weight: 600; font-size: 13px"
                >
                  <VAvatar :size="55" rounded color="green lighten-5" variant="tonal" class="me-3">
                    <v-icon size="34" color="green" dark>mdi-cash-multiple</v-icon>
                  </VAvatar>
                 <span class="mb-1" style="max-width: 90px; display: inline-flex;"
                      >Total Utilities <br />
                      This Month</span
                    > 
                  </v-list-item-title>  
              </v-list-item-content>

              <div align="center" justify="end">
                 <span class="subheading"
                  ><v-chip color="green" style="font-size: 13px; color: white; font-weight: 600"
                    >{{ formatMoney(totalUtilitiesThisMonth) }}</v-chip
                  ></span
                >
               
              </div>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="2">
        <v-card class="mx-auto" style="border: 0.5px solid purple">
          <v-card-actions>
            <v-list-item class="grow px-0">
              <v-list-item-content>
                <v-list-item-title
                  class="custom-form-label d-flex align-center"
                  style="font-weight: 600; font-size: 13px;"
                >
                  <VAvatar :size="55" rounded color="purple lighten-5" variant="tonal" class="me-1">
                    <v-icon size="34" color="purple" dark>mdi-cash-multiple</v-icon>
                  </VAvatar>
                   <span class="mb-1" style="max-width: 90px; display: inline-flex"
                      >Total Paid Utilities<br />
                      Last Month</span
                    > 
                  
                </v-list-item-title>
              </v-list-item-content>

              <div align="center" justify="end">
                 <span class="subheading"
                  ><v-chip color="purple" style="font-size: 13px; color: white; font-weight: 600"
                    >{{ formatMoney(totalUtilitiesLastMonth) }}</v-chip
                  ></span
                >
              
              </div>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </v-col>
   
    </v-row>
    <v-row>
      <v-col md="12" class="pl-2 mt-5" color="blue darken-4 ">
        <v-tabs
          active-class="custom-tab-active"
          v-model="productTab"
          background-color="transparent"
          color="blue darken-4"
          class="custom-tab-transparent tab-sticky"
        >
          <v-tab class="font-size-16 font-weight-600 px-8" href="#rent">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon"> </span>
            Rent
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#utility">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon"> </span>
            Utility
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#refund">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon"> </span>
            Refund/Credit
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="productTab">
          <v-tab-item value="rent">
            <Paymentlisting
              v-on:saveAddress="updateAddressPerson"
              v-on:totalPayments="gettotalPayments"
              v-on:totalUtilities="gettotalUtilities"
              v-on:totalRentPaidThisMonth="gettotalRentPaidThisMonth"
              v-on:totalRefundLastMonth="gettotalRefundPaidLastMonth"
              v-on:totalRefundThisMonth="gettotalRefundPaidThisMonth"
              v-on:totalRentPaidLastMonth="gettotalRentPaidLastMonth"
              v-on:totalUtilitiesThisMonth="gettotalPaidUtilitiesThisMonth"
              v-on:totalUtilitiesLastMonth="gettotalPaidUtilitiesLastMonth"
              :status="status"
            ></Paymentlisting>
          </v-tab-item>
          <v-tab-item value="utility">
            <Utilitylisting 
              v-on:utility="utilities"
              ref="utilityListing"
              v-on:saveAddress="updateAddressPerson"
              v-on:totalPayments="gettotalPayments"
              v-on:totalUtilities="gettotalUtilities"
                v-on:totalRefundLastMonth="gettotalRefundPaidLastMonth"
              v-on:totalRefundThisMonth="gettotalRefundPaidThisMonth"
              v-on:totalRentPaidThisMonth="gettotalRentPaidThisMonth"
             v-on:totalRentPaidLastMonth="gettotalRentPaidLastMonth"
              v-on:totalUtilitiesThisMonth="gettotalPaidUtilitiesThisMonth"
              v-on:totalUtilitiesLastMonth="gettotalPaidUtilitiesLastMonth"
            ></Utilitylisting>
          </v-tab-item>
          <v-tab-item value="refund">
            <RefundListing 
              v-on:utility="utilities"
              ref="refundListing"
              v-on:saveAddress="updateAddressPerson"
              v-on:totalPayments="gettotalPayments"
              v-on:totalUtilities="gettotalUtilities"
                 v-on:totalRefundLastMonth="gettotalRefundPaidLastMonth"
              v-on:totalRefundThisMonth="gettotalRefundPaidThisMonth"
              v-on:totalRentPaidThisMonth="gettotalRentPaidThisMonth"
              v-on:totalRentPaidLastMonth="gettotalRentPaidLastMonth"
              v-on:totalUtilitiesThisMonth="gettotalPaidUtilitiesThisMonth"
              v-on:totalUtilitiesLastMonth="gettotalPaidUtilitiesLastMonth"
            ></RefundListing>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
import Paymentlisting from "./Payment-Listing.vue";
import Utilitylisting from "./Utility-Listing.vue";
import RefundListing from "./Refund-Listing.vue";

import {
  SET_SEARCH_TITLE,
  SET_SEARCH_BAR,
  BEFORE_DESTROY,
} from "@/core/services/store/listing.module";
import { mapGetters } from "vuex";
import { format } from "date-fns";
// import { GET_AVAILABLE_VOUCHERS, GET_COLLECTED_VOUCHERS } from "@/core/lib/common.lib";
// import SelectInput from "@/view/components/SelectInput.vue";
import { formatMoney } from "accounting-js";

export default {
  name: "payment-listing",
  title: "Listing Payment",
  data() {
    return {
      text: "Also called a company description, your business description summarizes what your company does, its purpose, and what makes it unique. It's a critical component of your business plan and immediately follows your executive summary",
      dialog: false,
      total: 0,
      totalPayments: 0, 
      totalUtilities: 0,
      totalUtilitiesThisMonth: 0,
      totalUtilitiesLastMonth: 0,
      totalRefundThisMonth: 0,
      totalRefundLastMonth: 0,
      totalRentPaidThisMonth: 0,
      totalRentPaidLastMonth: 0, 
      type: 2,
 
      status: [
        {
          name: "All",
          color: "blue",
        },
        {
          name: "Active",
          color: "green",
        },
        { name: "InActive", color: "red" },
      ],
      promotionTableHeading: [
        { title: "ACTION", status: true },
        { title: "IMAGES", status: true },
        { title: "TYPE", status: true },
        { title: "TITLE", status: true },
        { title: "DESCRIPTION", status: true },
        { title: "START DATE", status: true },
        { title: "EXPIRY DATE", status: true },
        { title: "PUBLISH DATE", status: true },
      ],
      promotionTableData: [
        {
          code: "XMH36",
          action: { value: "", key: "ACTION" },
          title: { value: "BUSINESS", key: "TITLE" },
          type: { value: "MEMBERS", key: "TYPE" },
          description: { value: "DESCRIPTION", key: "DESCRIPTION" },
          start_date: { value: "8/08/2023", key: "START DATE" },
          expiry_date: { value: "28/08/2023", key: "END DATE" },
          publish_date: { value: "28/08/2023", key: "PUBLISH DATE" },
          images: {
            value: "https://cdn.pixabay.com/photo/2023/07/04/18/10/wreath-8106795_640.png",
            key: "IMAGES",
          },
        },
        {
          code: "XMQ96",
          action: { value: "", key: "ACTION" },
          title: { value: "CAP STOCKER", key: "TITLE" },
          type: { value: "PREMIUM", key: "TYPE" },
          description: { value: "DESCRIPTION", key: "DESCRIPTION" },
          start_date: { value: "8/08/2023", key: "START DATE" },
          expiry_date: { value: "28/08/2023", key: "END DATE" },
          publish_date: { value: "28/08/2023", key: "PUBLISH DATE" },
          images: {
            value:
              "https://plus.unsplash.com/premium_photo-1661953124283-76d0a8436b87?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8cmVzdGF1cmFudHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
            key: "IMAGES",
          },
        },
      ],
      dragStartIndex: null,
      dragOverIndex: null,
      templateList: [{ text: "First", value: "first" }],
      template: "first",
      whatsapp: {
        files: [],
        template: "first",
      },
      filterType: "all",
      filterDateRange: null,
      speedDial: [],
      whatsappPromotional: false,
      promotions: [],
      currentPage: 1,
      pageLimit: 1,
      showingFrom: 0,
      showingTo: 0,
      totalRows: 0,
      pageLoading: true,
      deleteText: null,
      deleteEndpoint: null,
      deleteDialog: false,
      promotionId: null,
      orderDialog: false,
      rOrderId: 0,
      rOrderCode: null,
      rLoading: false,
      rVouchers: [],
      redeemDialog: false,
      cOrderId: 0,
      cOrderCode: null,
      cLoading: false,
      cVouchers: [],
      collectDialog: false,
      allCollectedDialog: false,
      order: {
        id: null,
        date: format(new Date(), "yyyy-MM-dd"),
        time: format(new Date(), "HH:mm"),
        bill_no: null,
        amount: null,
        voucher: "none",
      },
    };
  },
  watch: {
    productTab: {
      handler(newVal, oldVal) {
        if (newVal === 'utility') {
          console.log(oldVal);
          
          this.$nextTick(() => {
            const utilityComponent = this.$refs.utilityListing;
            if (utilityComponent) {
              utilityComponent.getPaymentTypes();
            }
          });
        }
        if (newVal === 'refund') {
          console.log(oldVal);
          
          this.$nextTick(() => {
            const refundComponent = this.$refs.refundListing;
            if (refundComponent) {
              refundComponent.getPaymentTypes();
            }
          });
        }
      }
    }
  },

  methods: {
    updateAddressPerson(param) {
      this.total = param;
    },
    formatMoney(money) {
      return formatMoney(money, {
        symbol: "RM",
        decimal: ".",
        thousand: ",",
        precision: 2,
        format: "%s%v",
      });
    },
    gettotalPayments(param) {
      this.totalPayments = param;
    }, 
    gettotalUtilities(param){
      this.totalUtilities = param;
    
    },
    gettotalPaidUtilitiesLastMonth(param){
      this.totalUtilitiesLastMonth = param;
    }
    ,
    gettotalPaidUtilitiesThisMonth(param){
      this.totalUtilitiesThisMonth = param;
    },
    gettotalRentPaidLastMonth(param){
      this.totalRentPaidLastMonth = param;
    },
    gettotalRentPaidThisMonth(param){
      this.totalRentPaidThisMonth = param;
    },
    gettotalRefundPaidThisMonth(param){
      this.totalRefundThisMonth = param;
    },
    gettotalRefundPaidLastMonth(param){
      this.totalRefundLastMonth = param;
    },


    routeToUpdate(id) {
      this.$router.push({
        name: "payment",
        params: { id },
        query: { t: new Date().getTime() },
      });
    },
    routeToDetail(id) {
      this.$router.push({
        name: "payment",
        params: { id },
        query: { t: new Date().getTime() },
      });
    },
  },
  async mounted() {
    this.$store.dispatch(SET_SEARCH_BAR, true);
  },
  beforeDestroy() {
    this.$store.dispatch(BEFORE_DESTROY);
  },
  components: { 
    Paymentlisting,
    Utilitylisting,
    RefundListing
  },
  computed: {
    ...mapGetters(["listingSearch"]),
    productTab: {
      set(val) {
        let query = { ...this.$route.query };
        query.tab = val;
        query.t = new Date().getTime();
          this.$store.dispatch(SET_SEARCH_TITLE, val);

        if (val != this.productTab) {
          this.$router.replace({ query });
        }
      },
      get() {
        return this.$route.query.tab || "rent";
      },
    },
  },
};
</script>

<style>
.table_height .v-data-table__wrapper {
  height: calc(100vh - 360px);
}

.promotion-listing-tr:nth-child(even):hover {
  box-shadow: 0px 0px 10px #666666 !important;
  -webkit-box-shadow: 0px 0px 10px #666666 !important;
  -moz-box-shadow: 0px 0px 10px #666666 !important;
  background-color: #e3f2fd !important;
  position: relative;
  z-index: 5;
}

.promotion-listing-tr:nth-child(odd):hover {
  box-shadow: 0px 0px 10px #666666 !important;
  -webkit-box-shadow: 0px 0px 10px #666666 !important;
  -moz-box-shadow: 0px 0px 10px #666666 !important;
}
.custom_field_height v-input__control {
  max-height: 34px;
  height: 34px;
}
.custom_field_height .v-select__selection {
  max-width: 84%;
}
</style>
